import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d2ad8cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ub ub-ver fw print-item" }
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "ub ub-ac ub-ps fw print-header",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.collapsed = !_ctx.collapsed))
    }, [
      _createElementVNode("img", {
        src: _ctx.themeName == 'green' ? _ctx.downImgGreen : _ctx.downImg,
        class: _normalizeClass(["header-icon", _ctx.collapsed ? 'translat180' : 'translat0'])
      }, null, 10, _hoisted_2),
      _renderSlot(_ctx.$slots, "header", {}, undefined, true)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["ub ub-ver fw print-content", _ctx.collapsed ? 'collapsed' : ''])
    }, [
      _renderSlot(_ctx.$slots, "body", {}, undefined, true)
    ], 2)
  ]))
}